import React from 'react';

function ButtonsDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Variants</div>
        <button
          type='button'
          className='btn'
        >
          <i className='fa-solid fa-eraser' /> Default (secondary)
        </button>
        <button
          type='button'
          className='btn primary'
        >
          <i className='fa-solid fa-search' /> Primary (CTA)
        </button>
        <button
          type='button'
          className='btn navy'
        >
          <i className='fa-solid fa-floppy-disk' /> Navy
        </button>
        <button
          type='button'
          className='btn ghost'
        >
          <i className='fa-solid fa-xmark' /> Ghost
        </button>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Sizes & states</div>
        <button
          type='button'
          className='btn primary sm'
        >
          Small primary
        </button>
        <button
          type='button'
          className='btn sm'
        >
          Small default
        </button>
        <button
          type='button'
          className='btn primary'
          disabled
        >
          Disabled
        </button>
        <button
          type='button'
          className='icon-btn'
          title='Icon button'
        >
          <i className='fa-solid fa-rotate' />
        </button>
        <button
          type='button'
          className='icon-btn'
          disabled
          title='Disabled icon button'
        >
          <i className='fa-solid fa-rotate' />
        </button>
      </div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>With filter-count badge (Filters toolbar pattern)</div>
        <button
          type='button'
          className='btn'
        >
          <i className='fa-solid fa-sliders' />
          <span className='btn-label'>Filters</span>
          <span className='fcount'>3</span>
        </button>
      </div>
    </div>
  );
}

export const buttonsDemo = {
  id: 'buttons',
  title: 'Buttons',
  category: 'Basics',
  importPath: 'src/Css/design-system/bravo-ds.css (.btn / .icon-btn)',
  notes: [
    'Plain <button> elements styled by bravo-ds classes — there is no Button component.',
    'Classes only apply inside a .bravo-ds subtree.',
    'Variants: .btn (secondary default), .btn.primary (red CTA), .btn.navy, .btn.ghost; .sm for 30px height; [disabled] gets opacity 0.45 automatically.',
    '.icon-btn is the 36x36 square icon-only button.',
  ],
  snippet:
    "<button type='button' className='btn primary' onClick={handleSearch}>\n  <i className='fa-solid fa-search' /> Search\n</button>",
  render: ButtonsDemoComponent,
};
